const cleanTables = () => {
  const tables = document.querySelectorAll('.product-details table');

  tables.forEach(table => {
    table.className = 'table';
    table.removeAttribute('cellpadding');
    table.removeAttribute('cellspacing');
    table.removeAttribute('style');

    table.querySelectorAll('tr, td, th').forEach(el => {
      el.className = '';
      el.removeAttribute('valign');
      el.removeAttribute('style');
    });

    table.querySelectorAll('td, th').forEach(cell => {
      // Concatenar todo o texto dentro da célula (inclusive de <p>, <span>, etc.)
      const textContent = Array.from(cell.childNodes)
        .map(node => node.textContent)
        .join('')
        .trim();

      cell.innerHTML = textContent;
    });


    const wrapper = document.createElement('div');
    wrapper.className = 'table-wrapper';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
};

const applyFontWeightToNumbers = () => {
  const cells = document.querySelectorAll('.product-details .table-wrapper td');
  cells.forEach(cell => {
    const text = cell.textContent.trim();
    if (/^\d+(?:[.,]\d+)?(?:-\d+(?:[.,]\d+)?)?$/.test(text)) {
      cell.style.fontWeight = '400';
    }
  });
};

const observer = new MutationObserver(() => {
  const hasTable = document.querySelector('.product-details table');
  if (hasTable) {
    cleanTables();
    applyFontWeightToNumbers();
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });
